module.exports = __webpack_public_path__ + "static/why-good-leaders-thumbnail.a0ef3703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/why-good-leaders-thumbnail.jpg
// module id = 488
// module chunks = 59963396046441